var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container main-width-container"},_vm._l((_vm.dataList),function(item){return _c(_vm.cardType,{key:item.id,tag:"component",attrs:{"cardData":item,"showDate":_vm.showDate,"showView":_vm.showView,"contentType":_vm.contentType}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }